import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import uploadsApi from '../../api/uploadsApi';

const AuthenticatedImage = React.forwardRef(({ src, alt, sx, onError, onClick, onLoad }, ref) => {
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchImageUrl = async () => {
      if (!src) {
        if (!isCancelled) {
          setImageUrl('');
          setLoading(false);
        }
        return;
      }
      setLoading(true);
      try {
        const url = await uploadsApi.getSecureUrl(src);
        if (!isCancelled) {
          setImageUrl(url);
        }
      } catch (error) {
        console.error(`Failed to get secure URL for ${src}`, error);
        if (!isCancelled && onError) {
          onError(error);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchImageUrl();

    return () => {
      isCancelled = true;
    };
  }, [src]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ...sx }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      ref={ref}
      src={imageUrl}
      alt={alt}
      sx={sx}
      onError={onError}
      onClick={onClick}
      onLoad={onLoad}
    />
  );
});

export default React.memo(AuthenticatedImage);